import React from 'react';
import ReactDOM from 'react-dom';
import 'what-input';
import $ from 'jquery';
import store from 'store2';
import { Foundation } from 'foundation-sites/js/foundation.core';
Foundation.addToJquery($);
import { Triggers } from 'foundation-sites/js/foundation.util.triggers';
Triggers.init($, Foundation);
import 'odometer/themes/odometer-theme-default.css';
import './assets/cms_links_shim';

__webpack_public_path__ = `${window.UI_PATH}/`;

import App from './App';
import { checkRequiresUpgrade, renderUpgrade } from './upgrade';
import dismissLoadingScreen from './common/dismissLoadingScreen';

export const render = () => {
  const token = store.get('byo.auth');

  if (window.AUTH_CONTEXT.enabled && !token) {
    window.location.replace(window.AUTH_CONTEXT.redirectUrl);
    return;
  }

  const el = document.querySelector('.main-wrapper');

  if (checkRequiresUpgrade()) {
    dismissLoadingScreen();
    renderUpgrade(el);
  } else {
    ReactDOM.render(<App />, el);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    render();
  });
} else {
  render();
}
